
















import Vue from 'vue'

import LikertItem from './likert/Item.vue'
import YesOrNo from './YesOrNo.vue'
import Months from './Months.vue'
import TextField from './text/Field.vue'
import TextArea from './text/Area.vue'
import NumberVue from './Number.vue'
import Choice from './Choice.vue'
import Options from './options/Collection.vue'
import Instruction from './Instruction.vue'
import ChooseCountry from './ChooseCountry.vue'
import {
  allRequiredVariablesArePresent,
  missingRequiredVariables,
  Requirable,
  getRequiredVariables,
} from '../utils'

export default Vue.extend({
  computed: {
    firstUnreadyStep(): number {
      return this.readySteps.indexOf(false)
    },
    firstEmptyRequiredVariable(): string | undefined {
      return [...this.missingRequiredVariables].shift()
    },
    requiredVariables(): string[] {
      return getRequiredVariables(this.steps as Requirable[], this.value)
    },
    missingRequiredVariables(): string[] {
      return missingRequiredVariables(this.steps as Requirable[], this.value)
    },
    requiredValuesArePresent(): boolean {
      return allRequiredVariablesArePresent(this.steps as Requirable[], this.value)
    },
    ready(): boolean {
      return this.requiredValuesArePresent && this.readySteps.every(e => e)
    },
  },
  data() {
    return {
      readySteps: this.steps.map(() => false),
    }
  },
  methods: {
    chooseComponent(step: { type: string }) {
      switch (step.type.toLowerCase()) {
        case 'likert':
          return LikertItem
        case 'yes-or-no':
          return YesOrNo
        case 'months':
          return Months
        case 'text':
          return TextField
        case 'long-text':
          return TextArea
        case 'numeric':
          return NumberVue
        case 'choice':
          return Choice
        case 'options':
          return Options
        case 'instruction':
          return Instruction
        case 'choose-country':
          return ChooseCountry
        default:
          throw new Error(
            'unknown step type: ' + step.type + ', expected one of {likert,yes-or-no,months,text}'
          )
      }
    },
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
})
